<template>

    <div
        class="ios-add-to-homescreen"
        :class="{'is-ipad': isIpad, 'is-iphone': isIphone, 'is-android': isAndroid}"
        v-if="showIosAddToHomescreenBannerMessage"
    >
        <div class="walkthrough">
            <span class="arrow">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="63.553px" height="63.553px" viewBox="0 0 63.553 63.553" style="enable-background:new 0 0 63.553 63.553;" xml:space="preserve">
                    <g>
                        <path d="M62.97,31.191L32.608,0.827c0,0-0.004,0-0.004-0.002L31.776,0l-0.826,0.824l0,0L0.585,31.191
                            c-0.456,0.454-0.456,1.195,0,1.651c0.452,0.454,1.195,0.454,1.651,0l28.372-28.37v57.912c0,0.646,0.527,1.168,1.168,1.168
                            c0.644,0,1.168-0.522,1.168-1.168V4.473l28.372,28.37c0.228,0.23,0.526,0.342,0.825,0.342s0.598-0.114,0.828-0.342
                            C63.424,32.389,63.424,31.649,62.97,31.191z"/>
                    </g>
                </svg>
            </span>
            <div class="walkthrough-text-container">
                <img :src="require(`@/assets/img/logo-salesbox.svg`)" alt="Application Logo" class="application-logo">
                <div class="walkthrough-text" v-html="text"></div>
              <div class="prompt-installation" v-if="showBtnInstall">
               <br>{{ $t('or_click_link') }}<br><br>
                <button class="btn-install button is-primary is-large is-rounded is-uppercase is-background-color-red"  @click="install">{{ $t('app_install') }}</button><br>
              </div>
            </div>

            <div class="add-pwa-explanations">
                {{ $t('add_pwa_explanations') }}
            </div>

            <a
                href="javascript:;"
                class="continue-with-browser"
                @click="changeStateIosAddToHomescreenBanner(false)"
            >
                {{ $t('continue_with_browser') }}
            </a>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'ShowIosAddToHomescreenBanner',
        data() {
            return {
                showIosAddToHomescreenBannerMessage: false,
                isIphone: false,
                isIpad: false,
                isIos : false,
                isAndroid : false,
                isGoogleChrome: false,
                isSamsungBrowser: false,
                deferredPrompt: null,
                showBtnInstall: false
            }
        },
        async created() {
          let alreadyInstalled = false;
          if ('getInstalledRelatedApps' in window.navigator) {
            const relatedApps = await navigator.getInstalledRelatedApps();
            // console.log(relatedApps);
            relatedApps.forEach((app) => {
              //if your PWA exists in the array it is installed
              // console.log(app.platform, app.url);
              if (app.platform === 'webapp' && app.id === 'SalesBox PWA') alreadyInstalled = true;
            });
          }
          if (!alreadyInstalled) {
            window.addEventListener("beforeinstallprompt", e => {
              e.preventDefault();
              // Stash the event so it can be triggered later.
              this.deferredPrompt = e;
              this.showBtnInstall = true;
            });
            window.addEventListener("appinstalled", () => {
              this.dismiss();
            });

            // We display the overlay only if were not in developpement env
            //if(process.env.NODE_ENV !== 'development')
            this.showIosAddToHomescreenBanner();
          }
        },
        computed: {
            text(){
                let text = null;
                if(this.isIos){
                    text = this.$t('ios_add_to_homescreen_text');
                    text = text.replace('#1#', `<span class="share">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 125" style="enable-background:new 0 0 100 125;" xml:space="preserve">
                        <path d="M96.6,112.5H3.4c-1.4,0-2.5-1.1-2.5-2.5V38.3c0-1.4,1.1-2.5,2.5-2.5h21.4c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5H5.9
                            v66.8h88.2V40.8H76.3c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5h20.2c1.4,0,2.5,1.1,2.5,2.5V110C99.1,111.4,98,112.5,96.6,112.5
                            z M50.6,75.7c-1.4,0-2.5-1.1-2.5-2.5V15.3L33,29.6c-1,0.9-2.6,0.9-3.5-0.1c-0.9-1-0.9-2.6,0.1-3.5L48.9,7.8c1-0.9,2.4-0.9,3.4,0
                            L71.5,26c1,0.9,1,2.5,0.1,3.5s-2.5,1-3.5,0.1L53,15.3v57.9C53,74.6,51.9,75.7,50.6,75.7z"/>
                        </svg>
                    </span>`);
                        text = text.replace('#2#', `<span class="add-to-homescreen">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                            <path d="M12.5,1h-10C1.673,1,1,1.673,1,2.5v10C1,13.327,1.673,14,2.5,14h10c0.827,0,1.5-0.673,1.5-1.5v-10C14,1.673,13.327,1,12.5,1 z M11,8H8v3H7V8H4V7h3V4h1v3h3V8z"/>
                        </svg>
                    </span>`);
                }
                else if(this.isAndroid){
                    text = this.$t('android_add_to_homescreen_text');
                    text = text.replace('#1#', `<span class="three-dots">
                       <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                           <g>
                               <g>
                                   <g>
                                       <circle cx="256" cy="256" r="64"/>
                                       <circle cx="256" cy="448" r="64"/>
                                       <circle cx="256" cy="64" r="64"/>
                                   </g>
                               </g>
                           </g>
                       </svg>
                   </span>`);
                }
                return text;
            }
        },
        methods: {
          async dismiss() {
            this.deferredPrompt = null;
          },
          async install() {
            this.deferredPrompt.prompt();
          },
          showIosAddToHomescreenBanner() {
            const userAgent = window.navigator.userAgent.toLowerCase();

            this.isIphone = userAgent.match(/iphone/i);
            this.isIpad = userAgent.match(/ipad/i) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

            this.isIos = this.isIphone || this.isIpad;
            this.isAndroid = userAgent.match(/android/i);
            this.isSamsungBrowser = userAgent.match(/samsungbrowser/i);
            if(userAgent.indexOf('chrome') !== -1 || userAgent.indexOf('crios') !== -1) this.isGoogleChrome = true;

            const iosInStandaloneMode = () => (('standalone' in window.navigator) && (window.navigator.standalone));
            const androidInStandaloneMode = () => (window.matchMedia('(display-mode: standalone)').matches);
            const isMaybeInStandaloneMode = ((window.innerHeight / window.screen.height) > 0.92);

            if (
                (this.isIos && !iosInStandaloneMode() && !this.isGoogleChrome)
                ||
                (this.isAndroid && (!androidInStandaloneMode() && !this.isSamsungBrowser))
                ||
                (this.isSamsungBrowser && !isMaybeInStandaloneMode)
            ) {
              this.changeStateIosAddToHomescreenBanner(true)
            }
          },
          changeStateIosAddToHomescreenBanner(state) {
            this.$bus.$emit('blur', state);
            this.showIosAddToHomescreenBannerMessage = state;
          },
        },
    }
</script>

<style lang="scss" scoped>
    .ios-add-to-homescreen {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 99;

        &.is-ipad {
            .arrow {
                top: 5px;
                right: 107px;
                animation: bounceUp 2s infinite;
            }

            .walkthrough {
                margin-top: -5vh;

                .add-pwa-explanations {
                    font-size: 20px;
                    padding: 0 50px;
                }
            }
        }

        &.is-iphone {
            .arrow {
                bottom: calc(5px + 80px); // -70px pour le décallage viewport sur iphone
                left: 50%;
                margin-left: -35px;
                animation: bounceDown 2s infinite;

                svg {
                    transform: rotate(180deg);
                }
            }
        }

        &.is-android {
            .arrow {
                display: none;
            }
        }

        &.is-iphone, &.is-android {
            .walkthrough {
                margin-top: -5vh;

                .application-logo {
                    margin-bottom: 40px;
                    height: 60px;
                }


                &-text-container {
                    font-size: 18px;
                    line-height: 24px;

                    .share {
                        svg {
                            width: 24px;
                        }
                    }

                    .add-to-homescreen {
                        svg {
                            width: 24px;
                        }
                    }
                }

                .continue-with-browser {
                    font-size: 13px;
                }
            }
        }

        .arrow {
            position: absolute;
            display: inline-block;

            svg {
                width: 70px;
                text-align: center;

                path {
                    fill: #ffffff;
                }
            }
        }

        .walkthrough {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            height: 100%;

            &-text-container {
                font-size: 30px;
                line-height: 30px;
                font-weight: 300;
                color: #ffffff;

                .application-logo {
                    display: block;
                    margin: 0 auto 60px auto;
                    height: 100px;
                }

                /deep/ .share {
                    display: inline-block;
                    margin: 0 4px;

                    svg {
                        transform: translateY(5px);
                        width: 30px;

                        path {
                            fill: #ffffff;
                        }
                    }
                }

                /deep/ .add-to-homescreen {
                    display: inline-block;

                    svg {
                        transform: translateY(5px);
                        width: 30px;

                        path {
                            fill: #ffffff;
                        }
                    }
                }

                /deep/ .three-dots {
                    display: inline-block;

                    svg {
                        transform: translateY(5px);
                        width: 20px;

                        circle {
                            fill: #ffffff;
                        }
                    }
                }

                /deep/ .walkthrough-text {
                    strong {
                        color: #fff;
                    }
                }
            }

            .add-pwa-explanations {
                margin-top: 50px;
                padding: 0 20px;
                font-size: 16px;
                font-weight: 300;
                color: #ffffff;
            }

            .continue-with-browser {
                margin-top: 50px;
                font-size: 16px;
                font-weight: 300;
                color: #ffffff;
                text-decoration: underline;
            }
        }

        @keyframes bounceUp {
            0%, 20%, 50%, 80%, 100% {
                transform: translateY(0);
            }
            40% {
                transform: translateY(30px);
            }
            60% {
                transform: translateY(15px);
            }
        }

        @keyframes bounceDown {
            0%, 20%, 50%, 80%, 100% {
                transform: translateY(0);
            }
            40% {
                transform: translateY(-30px);
            }
            60% {
                transform: translateY(-15px);
            }
        }
    }
</style>